export const CHECKOUT_LABELS = 'checkout';
export const ACCOUNT_COMMON = 'account.common';
export const FAVORITES_LABELS = 'FavoritesLabels.FavoritesLabels_Sub';

export const lblAddToBag = 'lbl_add_to_bag';
export const lblDontHaveFavorites = 'lbl_dont_have_favorites';
export const lblAddFavoriteToYourList = 'lbl_add_favorite_to_your_list';
export const lblInspirationRequired = 'lbl_inspiration_required';
export const lblItemsToFavorite = 'lbl_items_to_favorite';
export const lblBiaNoProductsFoundMsg = 'lbl_bia_no_products_found_msg';

export const lblBiaMainTitle = 'lbl_bia_main_title';
export const lblBiaSubTitle = 'lbl_bia_sub_title';

const BuyItAgainLabels = {
  checkout: {
    bagPage: {
      [lblAddToBag]: 'Add to Bag',
    },
  },
  FavoritesLabels: {
    FavoritesLabels_Sub: {
      [lblDontHaveFavorites]: "Looks like you don't have any Favorites yet! ",
      [lblAddFavoriteToYourList]:
        'Add to your list(s) by clicking the heart next to each style. Save up to 5 lists!',
      [lblInspirationRequired]: 'Need some inspiration? ',
      [lblItemsToFavorite]: 'Here are some great items to get your Favorites started. ',
    },
  },
  account: {
    common: {
      [lblBiaNoProductsFoundMsg]:
        'Once you’ve made an order, you’ll be able to shop previously-purchased styles.',
      [lblBiaMainTitle]: 'Buy It Again',
      [lblBiaSubTitle]: 'Save time & shop your previously-purchased styles.',
    },
  },
};
export default BuyItAgainLabels;
